import axios from "axios";
import { notifications } from "@mantine/notifications";

const hostaddress = process.env.REACT_APP_API_URL;

export default function downloadFromBackend(documentId) {
  axios({
    url: `${hostaddress}/api/file/download/${documentId}`,
    method: "GET",
    responseType: "blob",
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const disposition = response.headers["content-disposition"];
      const match = disposition && disposition.match(/filename="?([^"]+)"?/);
      link.download = match ? match[1] : `document-${documentId}`;

      link.click();
      window.URL.revokeObjectURL(url);

      notifications.show({
        title: "Téléchargement réussi",
        message: "Le document a été téléchargé avec succès.",
        color: "green",
      });
    })
    .catch((error) => {
      console.error("Download error:", error);

      let message = "Erreur lors du téléchargement du fichier.";
      if (error.response?.status === 404) {
        message = "Le fichier est introuvable.";
      } else if (error.response?.status === 500) {
        message = "Erreur serveur pendant le téléchargement.";
      }

      notifications.show({
        title: "Erreur de téléchargement",
        message,
        color: "red",
      });
    });
}
